export enum RecurringPaymentAmountTypeEnum {
  Custom = 1,
  Minimum = 2
}
